import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, DataTable, PreviewAltCard, Row } from "../../components/Component";
import { Form, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import { createBrandAPI, createSpecializationAPI, listBrandAPI, listSpecializationAPI, updateBrandAPI, updateSpecializationAPI } from "../../api/master/indes";

import { toast } from "react-toastify";

import { BASE_URL_IMG } from "../../assets/constants";
import MyButton from "../../MyComp/UI/form/MyButton";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import useLogout from "../../hooks/useLogout";
import Table from "../../MyComp/UI/DataTable/Table";
const Specialization = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,

    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      data: [],
      meta_image: null,
      meta_img: null,
      product_banner_img: null,
      product_banner_image: null,
      product_images: [],
      productTypeDD: [],
      brandsDD: [],
      categoryDD: [],
      unitDD: [],
      ingredientDD: [],
      diseaseDD: [],
      isPub: false,
    },
  });
  const logout = useLogout();

  const [isOpen, setIsOpen] = useState(false);
  const [imageOpen, setImageOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");
  const [data, setData] = useState([]);

  const toggleCanvas = () => {
    setIsOpen((prev) => !prev);
    if (isOpen) resetF();
  };

  const selectorCheck = (e) => {
    const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
    setData(updated);
  };
  const handleTogglePublish = (row) => {
    setValue("isPub", true);
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const selectorDeleteUser = () => setData(data.filter((d) => !d.checked));
  const handleImageOpenPreview = (row) => {
    setImageOpen(!imageOpen);
    setValue("image_preview", row);
    trigger("image_preview");
  };

  const handleImageClose = () => {
    setImageOpen(!imageOpen);
  };

  const onSelectChange = (e, id) => {
    const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
    setData(updated);
  };
  const selectorSuspendUser = () => setData(data.map((d) => (d.checked ? { ...d, status: false } : d)));

  useEffect(() => {
    getSpecialization();
  }, []);

  const getSpecialization = () => {
    setValue("isLoading", true);
    listSpecializationAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data || []);
        } else {
          setData([]);
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };

  const onFormSubmit = () => {
    const body = {
      name: watch("specialization"),
      status: watch("status")?.value,
      ...(mode === "Edit" && { id: watch("selectedRow")?.id }),
    };

    const apiCall = mode === "Add" ? createSpecializationAPI(body) : updateSpecializationAPI(body);

    setValue("isLoading", true);

    apiCall
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status) {
          toast.success(res.data.message);
          getSpecialization();
          toggleCanvas();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };

  const handleEdit = (row) => {
    window.scrollTo(0, 0);
    setValue("selectedRow", row);
    setValue("specialization", row?.name);
    setValue("status", {
      label: row.status ? "Active" : "Inactive",
      value: row.status,
    });
    setMode("Edit");
    setIsOpen(true);
  };

  const handleToggleStatus = (row) => {
    setValue("selectedRow", row);
    setShowModal(true);
  };

  const confirmStatusChange = () => {
    const updatedStatus = !watch("selectedRow").status;
    const body = { id: watch("selectedRow").id, status: updatedStatus };

    setValue("isLoading", true);

    updateSpecializationAPI(body)
      .then((res) => {
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (res.data.status) {
          toast.success(res.data.message);
          getSpecialization();
          setShowModal(false);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => toast.error(err?.response?.data?.message))
      .finally(() => setValue("isLoading", false));
  };

  const resetF = () => {
    setValue("specialization", null);
    setValue("status", "");
    setMode("Add");
  };
  return (
    <>
      <Head title={"Product | Master"} />
      <Content>
        {/* <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Manage Products"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    setIsOpen((pre) => !pre);
                    resetF();
                  }}
                >
                  <Icon name={isOpen ? "minus" : "plus"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead> */}
        <Block>
          <>
            {" "}
            <div className="container my-5 text-center">
              {/* Button to open offcanvas */}

              <Offcanvas isOpen={isOpen} direction="end">
                <OffcanvasHeader toggle={toggleCanvas}>Specialization </OffcanvasHeader>
                <OffcanvasBody>
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row>
                        <Col md="12" className={``}>
                          <MyInput
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                            title={"Specialization"}
                            name={"specialization"}
                            placeholder={"Enter specialization name"}
                            required
                            min={2}
                            max={50}
                          />
                        </Col>
                        <Col md={`12`}>
                          <Status
                            register={register}
                            watch={watch}
                            setValue={setValue}
                            trigger={trigger}
                            errors={errors}
                          />
                        </Col>
                      </Row>
                      <Col md="12" className={``}>
                        <div className="form-group" style={{ marginTop: "31px" }}>
                          <MyButton isLoading={isLoading} mode={mode} />
                        </div>
                      </Col>
                    </Form>
                  </PreviewAltCard>
                </OffcanvasBody>
              </Offcanvas>
            </div>
          </>

          <Table
            title="Specialization List"
            data={data}
            publicButton={false}
            columns={[{ key: "name", label: "Name" }]}
            searchKeys={["name"]}
            nameColumn={"name"}
            imageBaseURL={BASE_URL_IMG}
            onEditClick={handleEdit}
            selectorCheck={selectorCheck}
            selectorDeleteUser={selectorDeleteUser}
            selectorSuspendUser={selectorSuspendUser}
            onSelectChange={onSelectChange}
            statusFilterEnabled={true}
            isOpen={isOpen}
            confirmStatusChange={confirmStatusChange}
            setIsOpen={setIsOpen}
            resetF={resetF}
            handleImageOpenPreview={handleImageOpenPreview}
            handleToggleStatus={handleToggleStatus}
            toggleCanvas={toggleCanvas}
            handleTogglePublish={handleTogglePublish}
          />
        </Block>
      </Content>
      <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
      <ConfirmModal
        isOpen={showModal}
        toggle={() => {
          setShowModal(!showModal);
          setValue("isPub", false);
        }}
        onConfirm={confirmStatusChange}
        status={watch("selectedRow")?.status}
        isPub={watch("isPub")}
        data={watch("selectedRow")}
      />
    </>
  );
};

export default Specialization;
